import styled from 'styled-components/macro'

export const AddIntermediateTokenWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`
